<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 2000 by Theresa DiBenedetto<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition November 2016<br/>
  ISBN: 978-1-68230-946-9</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">Also by Raine Cantrell</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample">A Corner of Heaven<br/>
  Calico<br/>
  Darling Annie<br/>
  Desert Sunrise<br/>
  Gifts of Love<br/>
  Silver Mist<br/>
  Tarnished Hearts<br/>
  The Homecoming<br/>
  Western Winds<br/>
  Whisper My Name</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample"><b><i>The Kincaids</i></b><br/>
  Once a Maverick<br/>
  Once an Outlaw<br/>
  Once a Lawman<br/>
  Once a Hero</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample"><b><i>Clan Gunn</i></b><br/>
  Fire and Sword<br/>
  Silk and Steel<br/>
  Magic and Mist</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample"><b><i>The Merry Widows</i></b><br/>
  Mary<br/>
  Catherine<br/>
  Sarah</span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/MoreFrom" title="Link target outside of Sample"><b><i>Novellas</i></b><br/>
  A Time for Giving<br/>
  Apache Fire<br/>
  Miss Delwin’s Delights<br/>
  More than a Miracle<br/>
  The Bride’s Gift<br/>
  The Secret Ingredient</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyrightpage.vue?175f8330